import { template as template_b76611375fbe42f8820bd5b7bcc03055 } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { cn } from '@cardstack/boxel-ui/helpers';
import { sanitizedHtml } from '@cardstack/host/helpers/sanitized-html';
import Message from './text-content';
interface Signature {
    Element: HTMLDivElement;
    Args: {
        html?: string;
        isPending?: boolean;
    };
    Blocks: {
        default: [];
    };
}
const UserMessage: TemplateOnlyComponent<Signature> = template_b76611375fbe42f8820bd5b7bcc03055(`
  <Message
    class={{cn 'user-message-bubble' is-pending=@isPending}}
    data-test-user-message
    ...attributes
  >
    {{yield}}

    {{#if @html}}
      {{sanitizedHtml @html}}
    {{/if}}
  </Message>

  <style scoped>
    .user-message-bubble {
      padding: var(--boxel-sp-sm);
      background-color: var(--boxel-light);
      color: var(--boxel-dark);
      border-radius: var(--boxel-border-radius-xxl);
      border-top-left-radius: var(--boxel-border-radius-xs);
    }
    .is-pending {
      --pill-background-color: var(--boxel-200);
      --pill-font-color: var(--boxel-500);
      background-color: var(--boxel-200);
      color: var(--boxel-500);
    }
    :deep(a:hover) {
      /* use this highlight text color on light-background */
      color: var(--boxel-highlight-hover);
    }
  </style>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default UserMessage;
